// Shared constants for patients module
export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const PAYMENT_METHODS = ['Efectivo', 'Tarjeta Crédito/Débito', 'Transferencia', 'Seguro Médico', 'Cuenta por Cobrar', 'Cortesía'];

export const OJO_OPTIONS = [
  { value: 'OD', label: 'Ojo Derecho (OD)' },
  { value: 'OI', label: 'Ojo Izquierdo (OI)' },
  { value: 'AO', label: 'Ambos Ojos (AO)' },
];

export const DISCOUNT_TYPES = [
  { value: 'sin_descuento', label: 'Sin descuento' },
  { value: 'porcentaje', label: 'Porcentaje %' },
  { value: 'cantidad', label: 'Cantidad Fija Q' },
];

export const INSTITUCION_OPTIONS = [
  'IGSS',
  'Particular',
  'Seguro Médico',
  'Convenio Empresarial',
  'Otro',
];

export const ITEMS_PER_PAGE = 15;

export const initialExamItem = {
  tipo_examen: '',
  ojo_estudiar: '',
  precio: '',
};

export const initialFormData = {
  fecha: '',
  nombre: '',
  fecha_nacimiento: '',
  edad: '',
  telefono: '',
  correo: '',
  nit: '',
  institucion: '',
  igss_afiliacion: '',
  igss_codigo: '',
  igss_nog: '',
  igss_spg: '',
  igss_unidad_referente: '',
  // Legacy fields for backwards compatibility
  ojo_estudiar: '',
  tipo_examen: '',
  precio: '',
  // New multiple exams
  examenes: [{ tipo_examen: '', ojo_estudiar: '', precio: '' }],
  medico_referente: '',
  tipo_descuento: 'sin_descuento',
  descuento: '0',
  medico_autoriza_descuento: '',
  forma_pago: 'Efectivo',
  no_autorizacion: '',
  observaciones: '',
  enviado: false,
  // Cuenta por cobrar
  fecha_limite_pago: '',
};

// Format currency
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('es-GT', {
    style: 'currency',
    currency: 'GTQ',
  }).format(amount || 0);
};

// Format date for display (dd/MM/yy)
export const formatDateDisplay = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr + 'T12:00:00');
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  } catch {
    return dateStr;
  }
};

// Calculate subtotal from exams
export const calculateSubtotal = (examenes) => {
  if (!examenes || examenes.length === 0) return 0;
  return examenes.reduce((sum, exam) => sum + (parseFloat(exam.precio) || 0), 0);
};

// Calculate total with discount
export const calculateTotal = (precio, tipo_descuento, descuento, examenes = null) => {
  // If examenes array is provided and has items, use sum of exam prices
  const p = examenes && examenes.length > 0 
    ? calculateSubtotal(examenes)
    : (parseFloat(precio) || 0);
  const d = parseFloat(descuento) || 0;
  
  if (tipo_descuento === 'porcentaje') {
    return p - (p * d / 100);
  } else if (tipo_descuento === 'cantidad') {
    return p - d;
  }
  return p;
};
